import { isTauri } from './platform';

export function getWebOrigin(): string {
  if (isTauri()) {
    return import.meta.env.MODE === 'development'
      ? 'https://atlas-staging.solidum-invest.de'
      : 'https://atlas.solidum-invest.de';
  }
  return window.location.origin;
}
